import { APP_CONFIG, generateBFFUrl } from '@/configs/apiEndPoints';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import axiosInstance from './axiosConfig';

export const fetchAppConfig = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(APP_CONFIG), {});
    const config = response?.data?.data?.attributes;
    delete config.createdAt;
    delete config.publishedAt;
    return response?.data?.data?.attributes || {};
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
